import { call, put, takeLatest } from "redux-saga/effects";
import GetStaffListRequest from "Communication/ApiClasses/GetStaffListRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";
import * as actionTypes from "Redux/Actions/actionTypes";

// worker
function* handleGetStaffList(action) {
  yield put(doLoadingStart(STRINGS.COMMON.API_KEYS.GET_STAFF_LIST));
  const getStaffList = new GetStaffListRequest();
  try {
    const result = yield call(getStaffList.getData);

    yield put({
      type: actionTypes.GET_STAFF_LIST_SUCCESS,
      response: result.data,
    });
    yield call(action.callback, result);
  } catch (error) {
    yield put({
      type: actionTypes.GET_STAFF_LIST_ERROR,
      error,
    });
  } finally {
    yield put(doLoadingFinish(STRINGS.COMMON.API_KEYS.GET_STAFF_LIST));
  }
}

// watcher
export default function* getStaffListWatcherSaga() {
  yield takeLatest(actionTypes.GET_STAFF_LIST, handleGetStaffList);
}
